"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processAlertsByLocation = void 0;
const types_1 = require("./../../types");
function processAlertsByLocation(sensors, fetchSensorAlerts) {
    return (async () => {
        const alertsPerLocations = {};
        for (const { location, id: sensorId, type, branchCircuits } of sensors) {
            const alerts = await fetchSensorAlerts(50, sensorId);
            if (type === types_1.SensorType.POWER && branchCircuits && branchCircuits.length > 0) {
                for (const branch of branchCircuits) {
                    if (branch.location) {
                        const branchAlerts = alerts.filter((alert) => alert.powerMonitorInputNumber === branch.powerMonitorInputNumber);
                        const currentAlerts = alertsPerLocations[branch.location] || [];
                        const allAlerts = [...currentAlerts, ...branchAlerts];
                        allAlerts.sort(types_1.sortAlertsBySeverityFunction);
                        alertsPerLocations[branch.location] = allAlerts;
                    }
                }
                continue;
            }
            const currentAlerts = alertsPerLocations[location] || [];
            const allAlerts = [...currentAlerts, ...alerts];
            allAlerts.sort(types_1.sortAlertsBySeverityFunction);
            alertsPerLocations[location] = allAlerts;
        }
        return alertsPerLocations;
    })();
}
exports.processAlertsByLocation = processAlertsByLocation;
